import React from "react";
import "./IncomeTable.scss";

const fmt = (val) =>
  Number(val ?? 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export function buildSections(cy, py) {
  return [
    {
      title: "TË ARDHURAT DHE KOSTOJA",
      items: [
        {
          id: "4000",
          code: "4000",
          label: "Të hyrat",
          note: "31",
          currentVal: cy.teArdhurat,
          priorVal: py.teArdhurat,
        },
        {
          id: "5000",
          code: "5000",
          label: "Kostoja e shitjes (KMSH)",
          note: "32",
          currentVal: cy.kmsh,
          priorVal: py.kmsh,
        },
        {
          id: "H",
          code: "H",
          label: "Fitimi / (humbja) bruto",
          currentVal: cy.fitimiBruto,
          priorVal: py.fitimiBruto,
          isTotal: true,
        },
      ],
    },
    {
      title: "SHPENZIMET OPERATIVE",
      items: [
        {
          id: "4100",
          code: "4100",
          label: "Të ardhurat tjera",
          note: "33",
          currentVal: cy.teArdhuraTjera,
          priorVal: py.teArdhuraTjera,
        },
        {
          id: "5100",
          code: "5100",
          label: "Shpenzimet e shpërndarjes",
          note: "34",
          currentVal: cy.shpenzimetShperndarjes,
          priorVal: py.shpenzimetShperndarjes,
        },
        {
          id: "5200",
          code: "5200",
          label: "Shpenzimet administrative",
          note: "35",
          currentVal: cy.shpenzimetAdministrative,
          priorVal: py.shpenzimetAdministrative,
        },
        {
          id: "5300",
          code: "5300",
          label: "Shpenzimet e tjera",
          note: "36",
          currentVal: cy.shpenzimetTjera,
          priorVal: py.shpenzimetTjera,
        },
        {
          id: "I",
          code: "I",
          label: "Fitimi / (humbja) operativ",
          currentVal: cy.fitimiOperativ,
          priorVal: py.fitimiOperativ,
          isTotal: true,
        },
      ],
    },
    {
      title: "TË ARDHURAT DHE SHPENZIMET FINANCIARE",
      items: [
        {
          id: "5400",
          code: "5400",
          label: "Shpenzimet financiare",
          note: "37",
          currentVal: cy.shpenzimetFinanciare,
          priorVal: py.shpenzimetFinanciare,
        },
        {
          id: "4200",
          code: "4200",
          label: "Të ardhurat financiare",
          note: "38",
          currentVal: cy.teArdhuratFinanciare,
          priorVal: py.teArdhuratFinanciare,
        },
        {
          id: "J",
          code: "J",
          label: "Fitimi / (humbja) para tatimit",
          currentVal: cy.fitimiParaTatimit,
          priorVal: py.fitimiParaTatimit,
          isTotal: true,
        },
      ],
    },
    {
      title: "TATIMI DHE FITIMI NETO",
      items: [
        {
          id: "5500",
          code: "5500",
          label: "Shpenzimet e tatimit në fitim",
          note: "39",
          currentVal: cy.tatimiFitim,
          priorVal: py.tatimiFitim,
        },
        {
          id: "K",
          code: "K",
          label: "Fitimi / (humbja) i/e vitit",
          currentVal: cy.fitimiNeto,
          priorVal: py.fitimiNeto,
          isTotal: true,
        },
      ],
    },
    {
      title: "TË ARDHURAT GJITHËPËRFSHIRËSE",
      items: [
        {
          id: "6000",
          code: "6000",
          label: "Diferenca këmbimore nga përkthimi i pasqyrave të operacioneve të huaja, neto nga tatimi",
          note: "40",
          currentVal: 0,
          priorVal: 0,
        },
        {
          id: "GjPf",
          code: "",
          label: "Të ardhurat tjera gjithëpërfshirëse të vitit",
          currentVal: cy.fitimiNeto,
          priorVal: py.fitimiNeto,
        },
        {
          id: "L",
          code: "L",
          label: "Gjithsej të ardhurat / (humbjet) gjithëpërfshirëse të vitit",
          currentVal: cy.gjithsejGjitheperfshirese,
          priorVal: py.gjithsejGjitheperfshirese,
          isTotal: true,
        },
      ],
    },
  ];
}

function LoadingSkeleton() {
  return (
    <div className="IS__Table__Loading">
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="IS__Table__LoadingCard" />
      ))}
    </div>
  );
}

export default function IncomeTable({ currentYear, priorYear, fiscalYear, loading }) {
  if (loading) return <LoadingSkeleton />;

  const cy = currentYear ?? {};
  const py = priorYear ?? {};
  const priorFiscalYear = Number(fiscalYear) - 1;
  const sections = buildSections(cy, py);

  return (
    <div className="IS__Table__Card">
      <div className="IS__Table__DesktopHeader">
        <div className="IS__Table__DH__Description">Përshkrimi</div>
        <div className="IS__Table__DH__Note">Shënimi</div>
        <div className="IS__Table__DH__Amount">Më 31.12.{fiscalYear}</div>
        <div className="IS__Table__DH__Amount">Më 31.12.{priorFiscalYear}</div>
      </div>

      <div className="IS__Table__Sections">
        {sections.map((section) => (
          <div key={section.title} className="IS__Table__Section">
            <div className="IS__Table__SectionHeader">
              <h3>{section.title}</h3>
            </div>

            <div className="IS__Table__Rows">
              {section.items.map((item) => (
                <div
                  key={item.id}
                  className={[
                    "IS__Table__Row",
                    item.isTotal
                      ? "IS__Table__Row--total"
                      : "IS__Table__Row--default",
                  ].join(" ")}
                >
                  <div className="IS__Table__DescriptionWrap">
                    <span className="IS__Table__Code">{item.code}</span>
                    <div className="IS__Table__LabelWrap">
                      <span className="IS__Table__Label">{item.label}</span>
                      {item.note && (
                        <span className="IS__Table__MobileNote">
                          Shënimi {item.note}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="IS__Table__NoteCell">
                    {item.note && (
                      <span className="IS__Table__NoteValue">{item.note}</span>
                    )}
                  </div>

                  <div className="IS__Table__AmountCell">
                    <span className="IS__Table__AmountLabel">Aktual</span>
                    <span className="IS__Table__AmountValue">
                      {fmt(item.currentVal)}
                    </span>
                  </div>

                  <div className="IS__Table__AmountCell IS__Table__AmountCell--prior">
                    <span className="IS__Table__AmountLabel">Paraprak</span>
                    <span className="IS__Table__AmountValue">
                      {fmt(item.priorVal)}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
